import React, { Suspense } from "react";

const GoogleChart = React.lazy(() =>
    import("react-google-charts").then((mod) => ({ default: mod.Chart }))
);

/** Monta o gráfico só quando entra (ou chega perto) da viewport. */
class VisibleNearViewport extends React.Component {
    constructor(props) {
        super(props);
        this.state = { visible: false };
        this.ref = React.createRef();
        this.observer = null;
    }

    componentDidMount() {
        if (typeof IntersectionObserver === "undefined") {
            this.setState({ visible: true });
            return;
        }

        this.observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    this.setState({ visible: true });
                    this.observer.disconnect();
                    this.observer = null;
                }
            },
            { rootMargin: "120px", threshold: 0.01 }
        );

        if (this.ref.current) {
            this.observer.observe(this.ref.current);
        }
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    render() {
        const height = this.props.height || "250px";

        return (
            <div ref={this.ref} style={{ width: "100%", minHeight: height }}>
                {this.state.visible ? this.props.children : (
                    <div className="d-flex justify-content-center align-items-center" style={{ height }}>
                        <div className="spinner-border spinner-border-sm text-secondary" role="status">
                            <span className="visually-hidden">...</span>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default function ChartLazy(props) {
    const height = props.height || "250px";

    return (
        <VisibleNearViewport height={height}>
            <Suspense
                fallback={
                    <div className="d-flex justify-content-center align-items-center" style={{ height }}>
                        <div className="spinner-border spinner-border-sm text-secondary" role="status">
                            <span className="visually-hidden">...</span>
                        </div>
                    </div>
                }
            >
                <GoogleChart {...props} />
            </Suspense>
        </VisibleNearViewport>
    );
}
